
exports.initializeTable = function(tableId, columns, data, options) {
    let pagination = (options === undefined || options.pagination === undefined) ? true : options.pagination;
    let layout = (options === undefined || options.layout === undefined) ? {} : options.layout;
    let sortable = (options === undefined || options.sortable === undefined) ? true : options.sortable;
    let rowCallback = (options === undefined || options.rowCallback === undefined) ? true : options.rowCallback;

    let table = $('#' + tableId).KTDatatable({
        data: {
            type: 'local',
            source: data,
            pageSize: 10,
        },
        rows: {
          autoHide: false,
          beforeTemplate: rowCallback,
        },
        columns: columns,
        sortable: sortable,
        pagination: pagination,
        layout: layout,
        search: {
            input: $('#kt_datatable_search_query'),
            key: 'generalSearch'
        },
      });

    let addFunction = false;
    columns.forEach(element => {if(element.top) addFunction=true;});
    if(addFunction) {
        $(table).on("datatable-on-layout-updated", function () {
            let tableHead = $(this).find('thead');
            let spans = $(tableHead).find('tr th span');

            let i;
            let myHeader = '<tr class="datatable-row" style="left:0;border-bottom:0">';
            for(i = 0; i < spans.length; i++) {
              let col = columns[i];
              let num = 1;
              let title = "";
              if(col.top) {
                num = col.top.span;
                title = col.top.title;
              }

              let j;
              let width = 0;
              for(j = 0; j < num; j++) {
                width += $(spans.get(i+j)).outerWidth();
              }

              width += (num - 1) * 5;

              i += (num-1);
              myHeader += '<th class="datatable-cell" style="padding-bottom: 0;"><span style="overflow:hidden;width:' + width + 'px;">' + title + '</span></th>';
            }

            myHeader += '</tr>';
            tableHead.prepend(myHeader);
        });
    }

    return table;
}



// WEBPACK FOOTER //
// ./client/app/_helpers/datatableUtil.js